import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IGroupedMarketing, IMarketings } from "./marketing.types";
import { generateAdvanceFilterQuery } from "../Accounting/AccountingReports/AccountingReportsActions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";

export const FETCH_MARKETINGS_HISTORY_LIST_PROGRESS =
  "FETCH_MARKETINGS_HISTORY_LIST_PROGRESS";
export const FETCH_MARKETINGS_HISTORY_LIST_SUCCESS =
  "FETCH_MARKETINGS_HISTORY_LIST_SUCCESS";
export const FETCH_MARKETINGS_HISTORY_LIST_FAILED =
  "FETCH_MARKETINGS_HISTORY_LIST_FAILED";

export const fetchMarketingsHistoryListProgress = () =>
  action(FETCH_MARKETINGS_HISTORY_LIST_PROGRESS);
export const fetchMarketingsHistoryListSuccess = (
  list: IGroupedMarketing[],
  totalRecords: number,
) => action(FETCH_MARKETINGS_HISTORY_LIST_SUCCESS, { list, totalRecords });
export const fetchMarketingsHistoryListFailed = () =>
  action(FETCH_MARKETINGS_HISTORY_LIST_FAILED);

const execGroupData = (data: IMarketings[]): IGroupedMarketing[] => {
  const groupedData = Object.values(
    data.reduce((acc, obj) => {
      //@ts-ignore
      if (!acc[obj.customer_policy_id]) {
        //@ts-ignore
        acc[obj.customer_policy_id] = {
          id: obj.customer_policy_id,
          ...obj,
          childs: [obj],
        };
      } else {
        //@ts-ignore
        acc[obj.customer_policy_id].childs.push(obj);
      }
      return acc;
    }, {}),
  );
  return groupedData as IGroupedMarketing[];
};

export const fetchMarketingsHistoryListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    searchState: { [key: string]: any },
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date, customer_policy_id, ...finalSearchState } =
        searchState;
      // Remove empty arrays and empty strings from search state
      const cleanedSearchState = Object.fromEntries(
        Object.entries(finalSearchState).filter(([_, v]) => {
          if (Array.isArray(v)) return v.length > 0;
          return v !== "" && v !== null && v !== undefined;
        }),
      );
      const query = generateAdvanceFilterQuery(cleanedSearchState);
      dispatch(fetchMarketingsHistoryListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&quote_status=" + status;
      }
      let finalUrl = `/tasks/get-all-policy-marketing-record?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}${url}`;
      if (query) {
        finalUrl = finalUrl + "&" + query;
      }
      const res = await api.get(finalUrl);

      const data: IMarketings[] = res.data.data;
      const finalData = execGroupData(data);

      const totalRecords = res.data.totalRecords;

      dispatch(fetchMarketingsHistoryListSuccess(finalData, totalRecords));
    } catch (err: any) {
      dispatch(fetchMarketingsHistoryListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_MARKETINGS_GROUPED_LIST_PROGRESS =
  "FETCH_MARKETINGS_GROUPED_LIST_PROGRESS";
export const FETCH_MARKETINGS_GROUPED_LIST_SUCCESS =
  "FETCH_MARKETINGS_GROUPED_LIST_SUCCESS";
export const FETCH_MARKETINGS_GROUPED_LIST_FAILED =
  "FETCH_MARKETINGS_GROUPED_LIST_FAILED";

export const fetchMarketingsGroupedListProgress = () =>
  action(FETCH_MARKETINGS_GROUPED_LIST_PROGRESS);
export const fetchMarketingsGroupedListSuccess = (list: IGroupedMarketing[]) =>
  action(FETCH_MARKETINGS_GROUPED_LIST_SUCCESS, { list });
export const fetchMarketingsGroupedListFailed = () =>
  action(FETCH_MARKETINGS_GROUPED_LIST_FAILED);

export const fetchMarketingsGroupedListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    date: IDataTableV2DateState["dates"],
    status: string,

  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchMarketingsGroupedListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&quote_status=" + status;
      }
      const finalUrl = `/tasks/get-all-policy-marketing?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}${url}`;
     
      const res = await api.get(finalUrl);

      const data: IGroupedMarketing[] = res.data.data;
      const finalData = execGroupData(data);

      dispatch(fetchMarketingsGroupedListSuccess(finalData));
    } catch (err: any) {
      dispatch(fetchMarketingsGroupedListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };
